/**
 * SoiLife Sticky Add-to-Cart Bar
 * Shows a fixed bottom bar when the hero ATC button scrolls out of view.
 * Reads from the existing #slph-product-form - does NOT create its own form.
 */
(function () {
  'use strict';

  /* ── Bail if not a product page with the hero form ── */
  var heroAtc = document.querySelector('.slph__atc');
  var heroAtcBtn = document.getElementById('slph-atc');
  if (!heroAtc || !heroAtcBtn) return;

  /* ── Inject styles ── */
  var css = [
    '#sticky-atc-bar {',
    '  position: fixed;',
    '  bottom: 0;',
    '  left: 0;',
    '  width: 100%;',
    '  height: 60px;',
    '  background: #113B2B;',
    '  color: #fff;',
    '  font-family: "Poppins", sans-serif;',
    '  display: flex;',
    '  align-items: center;',
    '  justify-content: space-between;',
    '  padding: 0 24px;',
    '  z-index: 999;',
    '  box-shadow: 0 -2px 12px rgba(0,0,0,.25);',
    '  transform: translateY(100%);',
    '  transition: transform .35s cubic-bezier(.4,0,.2,1);',
    '  box-sizing: border-box;',
    '}',
    '#sticky-atc-bar.is-visible {',
    '  transform: translateY(0);',
    '}',
    '#sticky-atc-bar.is-dismissed {',
    '  transform: translateY(100%) !important;',
    '}',
    '',
    '/* Left: product info */',
    '.satc__info {',
    '  display: flex;',
    '  align-items: center;',
    '  gap: 12px;',
    '  min-width: 0;',
    '  flex: 1 1 auto;',
    '}',
    '.satc__title {',
    '  font-size: 14px;',
    '  font-weight: 600;',
    '  white-space: nowrap;',
    '  overflow: hidden;',
    '  text-overflow: ellipsis;',
    '  max-width: 200px;',
    '}',
    '.satc__variant {',
    '  font-size: 12px;',
    '  opacity: .75;',
    '  white-space: nowrap;',
    '}',
    '.satc__sep {',
    '  width: 1px;',
    '  height: 20px;',
    '  background: rgba(255,255,255,.25);',
    '  flex-shrink: 0;',
    '}',
    '',
    '/* Right: price + button + close */',
    '.satc__actions {',
    '  display: flex;',
    '  align-items: center;',
    '  gap: 14px;',
    '  flex-shrink: 0;',
    '}',
    '.satc__price {',
    '  font-size: 16px;',
    '  font-weight: 700;',
    '  white-space: nowrap;',
    '}',
    '.satc__btn {',
    '  background: #9ec658;',
    '  color: #fff;',
    '  border: none;',
    '  border-radius: 8px;',
    '  padding: 10px 22px;',
    '  font-family: "Poppins", sans-serif;',
    '  font-size: 14px;',
    '  font-weight: 600;',
    '  cursor: pointer;',
    '  white-space: nowrap;',
    '  transition: background .2s;',
    '}',
    '.satc__btn:hover {',
    '  background: #7aa347;',
    '}',
    '.satc__close {',
    '  background: none;',
    '  border: none;',
    '  color: rgba(255,255,255,.6);',
    '  font-size: 20px;',
    '  line-height: 1;',
    '  cursor: pointer;',
    '  padding: 4px;',
    '  transition: color .2s;',
    '}',
    '.satc__close:hover {',
    '  color: #fff;',
    '}',
    '',
    '/* Mobile: hide title + variant, keep price + button */',
    '@media (max-width: 749px) {',
    '  #sticky-atc-bar { padding: 0 14px; }',
    '  .satc__title,',
    '  .satc__variant,',
    '  .satc__sep { display: none; }',
    '  .satc__info { flex: 0 0 auto; }',
    '  .satc__price { font-size: 15px; }',
    '  .satc__btn { padding: 9px 18px; font-size: 13px; }',
    '}'
  ].join('\n');

  var styleEl = document.createElement('style');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  /* ── Read initial values from the hero ── */
  function getProductTitle() {
    var el = document.querySelector('.slph__title');
    return el ? el.textContent.trim() : 'Product';
  }

  function getVariantLabel() {
    var el = document.getElementById('slph-size-label');
    return el ? el.textContent.trim() : '';
  }

  function getCurrentPrice() {
    var el = document.getElementById('slph-price');
    return el ? el.textContent.trim() : '';
  }

  /* ── Build sticky bar ── */
  var bar = document.createElement('div');
  bar.id = 'sticky-atc-bar';
  bar.setAttribute('aria-label', 'Sticky add to cart');

  var titleSpan = document.createElement('span');
  titleSpan.className = 'satc__title';
  titleSpan.textContent = getProductTitle();

  var variantSpan = document.createElement('span');
  variantSpan.className = 'satc__variant';
  variantSpan.textContent = getVariantLabel();

  var sep = document.createElement('span');
  sep.className = 'satc__sep';

  var infoDiv = document.createElement('div');
  infoDiv.className = 'satc__info';
  infoDiv.appendChild(titleSpan);
  if (getVariantLabel()) {
    infoDiv.appendChild(sep);
    infoDiv.appendChild(variantSpan);
  }

  var priceSpan = document.createElement('span');
  priceSpan.className = 'satc__price';
  priceSpan.textContent = getCurrentPrice();

  var atcButton = document.createElement('button');
  atcButton.type = 'button';
  atcButton.className = 'satc__btn';
  atcButton.textContent = 'Add to Cart';

  var closeBtn = document.createElement('button');
  closeBtn.type = 'button';
  closeBtn.className = 'satc__close';
  closeBtn.setAttribute('aria-label', 'Dismiss sticky bar');
  closeBtn.innerHTML = '&times;';

  var actionsDiv = document.createElement('div');
  actionsDiv.className = 'satc__actions';
  actionsDiv.appendChild(priceSpan);
  actionsDiv.appendChild(atcButton);
  actionsDiv.appendChild(closeBtn);

  bar.appendChild(infoDiv);
  bar.appendChild(actionsDiv);
  document.body.appendChild(bar);

  /* ── Keep bar in sync when variant changes ── */
  var pills = document.querySelectorAll('.slph__pill input[type="radio"]');
  pills.forEach(function (pill) {
    pill.addEventListener('change', function () {
      // Small delay so the hero JS updates the DOM first
      setTimeout(function () {
        variantSpan.textContent = getVariantLabel();
        priceSpan.textContent = getCurrentPrice();
        // Ensure separator is present when a variant label exists
        if (getVariantLabel() && !infoDiv.contains(sep)) {
          infoDiv.appendChild(sep);
          infoDiv.appendChild(variantSpan);
        }
      }, 50);
    });
  });

  /* ── ATC click → trigger original button ── */
  atcButton.addEventListener('click', function () {
    if (!heroAtcBtn || heroAtcBtn.disabled) {
      atcButton.textContent = 'Sold Out';
      atcButton.style.opacity = '0.5';
      return;
    }
    atcButton.textContent = 'Adding...';
    atcButton.disabled = true;
    heroAtcBtn.click();
    // Reset after hero ATC completes
    setTimeout(function () {
      atcButton.textContent = 'Add to Cart';
      atcButton.disabled = false;
      atcButton.style.opacity = '';
    }, 2000);
  });

  /* ── Close / dismiss for session ── */
  var dismissed = false;
  function dismissBar() {
    dismissed = true;
    bar.classList.add('is-dismissed');
    try {
      sessionStorage.setItem('satc_dismissed', '1');
    } catch (e) { /* private browsing */ }
  }

  closeBtn.addEventListener('click', dismissBar);

  // Escape key dismisses sticky bar
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && bar.classList.contains('is-visible') && !dismissed) {
      dismissBar();
    }
  });

  // Restore dismissed state from session
  try {
    if (sessionStorage.getItem('satc_dismissed') === '1') {
      dismissed = true;
      bar.classList.add('is-dismissed');
    }
  } catch (e) { /* private browsing */ }

  /* ── IntersectionObserver: show/hide bar ── */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (dismissed) return;
          if (entry.isIntersecting) {
            // Hero ATC is visible → hide sticky bar
            bar.classList.remove('is-visible');
          } else {
            // Hero ATC scrolled away → show sticky bar
            bar.classList.add('is-visible');
          }
        });
      },
      { threshold: 0 }
    );
    observer.observe(heroAtc);
  } else {
    // Fallback for very old browsers: simple scroll listener
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        if (dismissed) { ticking = false; return; }
        var rect = heroAtc.getBoundingClientRect();
        var inView = rect.top < window.innerHeight && rect.bottom > 0;
        if (inView) {
          bar.classList.remove('is-visible');
        } else {
          bar.classList.add('is-visible');
        }
        ticking = false;
      });
    });
  }
})();
